import BaseAPI from '../baseApi';
import { Token } from '../interfaces';

export class TokenAPI extends BaseAPI {
  protected model = 'liquid/tokens';
  protected prefix = 'api/v1';

  protected token: Token = null;

  async getToken(clientId: string): Promise<Token> {
    if (!this.token || this.isTokenExpired(this.token)) {
      this.token = await this.get<Token>('', { clientId });
      this.token.expiresIn = Math.floor(Date.now() / 1000) + this.token.expiresIn;
    }

    return this.token;
  }

  protected isTokenExpired(token: Token): boolean {
    return !token || Math.floor(Date.now() / 1000) > token.expiresIn;
  }
}
